import makeCrudMetaReducer from 'weego-common/src/utils/makeCrudMetaReducer';
import { actionTypes as stopsActionTypes } from '../../actions/stops';

export default makeCrudMetaReducer(stopsActionTypes);
